export const FETCH_STATUS = {
  NONE: "NONE",
  FETCHING: "FETCHING",
  FETCHED: "FETCHED",
  ERROR: "ERROR"
};
